'use strict';

angular.module('internal.exams')
    .controller('ExamPacketModalController', ['$scope', '$uibModalInstance', 'forms', function ($scope, $uibModalInstance, forms) {
        $scope.modalForms = forms;

        $scope.select = function (form) {
            $uibModalInstance.close(form);
        }

        $scope.no = function () {
            $uibModalInstance.close(null);
        }
    }]);